import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Row, Col, Form, FormGroup, Input, Button } from "reactstrap";
import withRouter from "../../components/Common/withRouter";
import { post, put } from "../../api/axios";
import endpoints from "../../api/endpoints";
import * as Yup from "yup";
import { useFormik } from "formik";
import logo from "../../assets/images/elevated-logo.svg";
import login from "../../assets/images/login1.png";
import { toast, Bounce } from "react-toastify";
import { setLogin } from "../../store/slices/authSlice";
import { useDispatch } from "react-redux";
import { useLocation, Link } from "react-router-dom";

const VerifyEmail = (props) => {
  document.title = "Recover Password | Elevated Iron - Admin Dashboard";

  const location = useLocation();
  const [email, setEmail] = useState(location.state?.email || "");
  const [code, setCode] = useState(["", "", "", "", "", ""]);
  const [isResendEnabled, setIsResendEnabled] = useState(false);
  const [timer, setTimer] = useState(60);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      email: "",
    },
    validationSchema: Yup.object({
      email: Yup.string().required("Please Enter Your Email"),
    }),
    onSubmit: (values) => {
      console.log(values);
    },
  });

  useEffect(() => {
    document.body.className = "authentication-bg";
    return function cleanup() {
      document.body.className = "";
    };
  }, []);
  useEffect(() => {
    if (timer > 0) {
      const interval = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
      return () => clearInterval(interval);
    } else {
      setIsResendEnabled(true);
    }
  }, [timer]);

  const handleInputChange = (e, index) => {
    const newCode = [...code];
    newCode[index] = e.target.value;
    setCode(newCode);

    if (e.target.value.length === 1 && index < 5) {
      document.getElementById(`codeInput${index + 1}`).focus();
    }

    if (index === 5 && newCode.every((digit) => digit.length === 1)) {
      handleSubmitOTP(newCode.join(""));
    }
  };

  const handleSubmitOTP = async (otp) => {
    try {
      const response = await post(endpoints.verify, { token: otp });
      if (response.status === 200) {
        const { token, data } = response?.data;

        localStorage.setItem("accessToken", token);
        localStorage.setItem("userId", data?.id);

        if (
          response?.data?.data?.appRole == "admin" ||
          response?.data?.data?.appRole == "staff"
        ) {
          navigate("/dashboard");
        } else {
          navigate("/gymDashboard");
        }
        dispatch(
          setLogin({
            currentUser: data,
            jid: token,
            isAuth: true,
            loginType: "credentials",
          })
        );

        toast.success("Login Successful", {
          position: "bottom-center",
          theme: "colored",
          transition: Bounce,
        });
        const fcmToke = await localStorage.getItem("fcm");
        const fcmData = await put(endpoints.fcm, { fcm: fcmToke });
      } else {
        toast.error("Failed to verify OTP. Please try again.", {
          position: "bottom-center",
          theme: "colored",
          transition: Bounce,
        });
      }
    } catch (error) {
      alert("Failed to verify OTP. Please try again.");
    }
  };

  const handleResendCode = async () => {
    if (!isResendEnabled) return;

    try {
      const response = await post(endpoints.resendOtp, { email });
      if (response.status === 200) {
        toast.success("Verification code resent successfully!", {
          position: "bottom-center",
          theme: "colored",
          transition: Bounce,
        });
        setTimer(60);
        setIsResendEnabled(false);
      }
    } catch (error) {
      toast.error("Failed to resend code. Please try again.", {
        position: "bottom-center",
        theme: "colored",
        transition: Bounce,
      });
    }
  };

  const handleInputChanger = (e, index) => {
    const newCode = [...code];
    newCode[index] = e.target.value;

    setCode(newCode);

    if (e.target.value.length === 1 && index < 5) {
      document.getElementById(`codeInput${index + 1}`).focus();
    }

    if (index === 5 && newCode.every((digit) => digit.length === 1)) {
      handleSubmitOTP(newCode.join(""));
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !code[index] && index > 0) {
      document.getElementById(`codeInput${index - 1}`).focus();
    }
  };

  const handlePaste = (e, index) => {
    const pastedData = e.clipboardData.getData("Text");
    const newCode = [...code];

    for (let i = 0; i < pastedData.length; i++) {
      if (i < 6) {
        newCode[i] = pastedData[i];
      }
    }

    setCode(newCode);

    if (newCode.every((digit) => digit.length === 1)) {
      handleSubmitOTP(newCode.join(""));
    } else {
      const nextEmptyIndex = newCode.findIndex((digit) => digit === "");
      if (nextEmptyIndex >= 0) {
        document.getElementById(`codeInput${nextEmptyIndex}`).focus();
      }
    }

    e.preventDefault();
  };

  return (
    <React.Fragment>
      <div className=" account-pages bg-white">
        <Row className="d-flex align-items-center justify-content-center min-vh-100 g-0 px-3">
          <Col md="6" className="d-none d-xl-block">
            <div className="image-section">
              <img
                src={login}
                alt="Gym Equipment"
                className="object-fit-cover img-fluid w-100 rounded-5 "
                style={{ maxHeight: "96vh" }}
              />
            </div>
          </Col>
          <Col
            xl="6"
            className="d-flex align-items-center justify-content-center login-scroll"
          >
            <div className="text-center">
              <img src={logo} height={"140px"} alt="Logo" className="mb-3" />
              <h2 className="text-center mt-5 ff-sora fw-bold font-size-24 primary-black">
                Verify Email
              </h2>
              <p className="text-center ff-sora font-size-16 secondary-black fw-normal mb-0">
                Verification code has been sent to your <br /> email{" "}
                <strong>{email}</strong>
              </p>
              <p className="text-center ff-sora font-size-16 secondary-black fw-medium">
                {" "}
                <Link
                  to="/login"
                  className="text-center ff-sora font-size-16 secondary-black fw-medium "
                >
                  Change Email
                </Link>
              </p>

              <Form className="mt-4 overflow-hidden">
                <FormGroup row>
                  <Col>
                    <Row className="g-0 ps-xl-1">
                      {code.map((digit, index) => (
                        <Col key={index} className="p-0">
                          <Input
                            type="text"
                            maxLength="1"
                            value={digit}
                            onChange={(e) => handleInputChanger(e, index)}
                            onKeyDown={(e) => handleKeyDown(e, index)}
                            onPaste={(e) => handlePaste(e, index)}
                            id={`codeInput${index}`}
                            className="text-center rounded-pill bg-light  me-1 mt-2 mt-xl-0 ff-sora fw-normal font-size-16 primary-black"
                            style={{
                              width: "90px",
                              height: "60px",
                              padding: "10px",
                              border: "1px solid #ccc",
                              fontSize: "16px",
                              fontWeight: "noraml",
                              outline: "none",
                            }}
                          />
                        </Col>
                      ))}
                    </Row>
                  </Col>
                </FormGroup>
              </Form>
              <p className="text-center pt-4 ff-sora font-size-14 light-black font-weight-normal mb-0">
                If you didn’t receive a code, click the button below.
              </p>
              <div className="text-center ff-sora">
                {timer > 0 ? (
                  <strong>{`Resend available in 00:${timer}s`}</strong>
                ) : (
                  <Button
                    className="ff-sora font-size-16 fw-bold text-sub-black mt-2 pt-0"
                    color=""
                    onClick={handleResendCode}
                    style={{ border: "none" }}
                  >
                    Resend Code
                  </Button>
                )}
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </React.Fragment>
  );
};

export default withRouter(VerifyEmail);
